import React, { useMemo } from "react";
import styles from '../styles/vipBenefits.module.scss'
import { useAssetImage } from "@/platforms/utils";
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useUserInfo } from "@/api/request";
import { useVipCfgList } from "@/views/vip/hooks/useVip";
import { useNavigate } from "react-router";
import LoadingUI from "@/compoments/loadingUI";
import { useTranslation } from "react-i18next";

const VipBenefits = ({gradeData, userInfo}) => {
    const navigate = useNavigate()
    const { t } = useTranslation('centralWallet')
    const vipBenefits = useAssetImage('wallet-vipBenefits',{ theme: true})
    const walletVipIcon = useAssetImage('wallet-vip-icon',{ theme: true})
    const vipDj = useAssetImage('vip-vip-dj',{theme: true})
    const vipLevel = useAssetImage('vip-level',{theme: true})

    const { memberGradeConfigList: ConfigList, memberInfoChangeList: changeList } = gradeData || {}
    
    const progress = useMemo(() => {
        if (!changeList?.upNeedTotalRecharge) return 0;
        const raw = (changeList?.upTotalRecharge / changeList?.upNeedTotalRecharge) * 100
        return Math.min(Math.floor(raw), 100);
      }, [changeList])
      
    
    return <div className={styles.vipBenefits}
    style={{backgroundImage: `url(${vipBenefits})`}}
    >   
        
        <div className={styles.top}>
            <img src={walletVipIcon} alt="" />
            <div className={styles.content}>
                <div className={styles.text}>
                    <div>{t('vipBenefits')}</div>
                    <div>{t('joinVipGetGift')}</div>
                </div>
                <button onClick={()=>navigate('/vip/details')}>{t('viewVipDetails')}</button>
            </div>
        </div>

        <div className={styles.bottom}>
            <div className={styles.vip_Grade}>
                <img src={vipDj}  alt="" />
                <span>VIP{userInfo?.grade}</span>
            </div>
            <div className={styles.levelBar}>
                <div className={styles.barWrapper}>
                <img src={vipLevel} alt="" style={{ width: `${progress}%` }} />
                </div>
            </div>
            <div className={styles.vip_Grade}>
                <img src={vipDj}  alt="" />
                <span>VIP{userInfo?.grade + 1}</span>
            </div>
        </div>
    </div>
}

export default VipBenefits